export var DATE_FORMAT = 'DD-MM-YYYY';
export var DATE_FORMAT_COMMENTS = 'DD.MM.YYYY';
export var DATE_WITH_TIME_FORMAT_COMMENTS = 'DD.MM.YYYY HH:mm';
export var DATETIME_FORMAT = 'D MMM HH:mm';
export var SAMOLET_LK_HOST = 'pro.samoletgroup.ru';
export var SAMOLET_LK_STAGE_HOST = 'pro-stage.samoletgroup.ru';
export var SAMOLET_LK_LOCAL_HOST = 'localhost:8000';
export var SAMOLET_NOTIFICATION_HOST = 'notifications.samoletgroup.ru';
export var SAMOLET_NOTIFICATION_STAGE_HOST = 'notifications-stage.samoletgroup.ru';
export var SAMOLET_CENTRIFUGO_HOST = 'notifications-cf.samoletgroup.ru';
export var SAMOLET_CENTRIFUGO_STAGE_HOST = 'notifications-cf-stage.samoletgroup.ru';
export var SAMOLET_ID_HOST = 'id.samoletgroup.ru';
export var SAMOLET_ID_STAGE_HOST = 'id-stage.samoletgroup.ru';
export var SAMOLET_YM_COUNTER = 88977299;
export var CREATE_REQUEST_ENDPOINT = '/api/v1/issues/create';
export var SUGGEST_PROJECTS_ENDPOINT = '/api/v1/suggest/projects/';
export var SUGGEST_PROBLEMS_ENDPOINT = '/api/v1/suggest/problems/';
//# sourceMappingURL=common.js.map